module.exports = __webpack_public_path__ + "img/contact.6ffb8924.svg";